import type { Icon } from '@onefootprint/icons';
import {
  IcoBolt16,
  IcoBook16,
  IcoBuilding16,
  IcoEye16,
  IcoFileText16,
  IcoFlag16,
  IcoFlask16,
  IcoPaint16,
  IcoRobot16,
  IcoShield16,
  IcoStore16,
  IcoUserCircle16,
  IcoUsers16,
  IcoWarning16,
} from '@onefootprint/icons';
import type { TFunction } from 'i18next';

type HomeSuggestionId =
  | 'findInReview'
  | 'explainFlag'
  | 'sanctions'
  | 'playbookStep'
  | 'watchlistAgent'
  | 'brand'
  | 'summarize'
  | 'adverseMedia'
  | 'ownership'
  | 'report'
  | 'testUser'
  | 'runAgent'
  | 'kybAgent'
  | 'monitoring';

export type HomeSuggestion = {
  id: HomeSuggestionId;
  label: string;
  /** Shown as the home's headline while the cycle is on this suggestion. */
  headline: string;
  icon: Icon;
  prompt: string;
  /** Seeds the prompt with the composer on Sandbox: Percy writes to the chat's environment, and
   * the home starts on Production. */
  sandbox?: boolean;
};

// Each one is something Percy has a tool for in the dashboard chat.
export const buildHomeSuggestions = (t: TFunction<'ask-percy'>): HomeSuggestion[] => {
  const suggestion = (id: HomeSuggestionId, icon: Icon, options?: { sandbox: boolean }): HomeSuggestion => ({
    id,
    icon,
    label: t($ => $.home.suggestions[id].label),
    headline: t($ => $.home.suggestions[id].headline),
    prompt: t($ => $.home.suggestions[id].prompt),
    ...options,
  });

  return [
    suggestion('findInReview', IcoUsers16),
    suggestion('explainFlag', IcoFlag16),
    suggestion('sanctions', IcoShield16),
    suggestion('playbookStep', IcoBook16),
    suggestion('watchlistAgent', IcoRobot16),
    suggestion('brand', IcoPaint16),
    suggestion('summarize', IcoUserCircle16),
    suggestion('adverseMedia', IcoWarning16),
    suggestion('ownership', IcoBuilding16),
    suggestion('report', IcoFileText16),
    suggestion('testUser', IcoFlask16, { sandbox: true }),
    suggestion('runAgent', IcoBolt16),
    suggestion('kybAgent', IcoStore16),
    suggestion('monitoring', IcoEye16),
  ];
};
